import { Component, inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { OpportunitySnapshotsService } from '../../services/opportunity-snapshots.service';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { IpAddressService } from '../../services/ip-address.service';
import { OpportunitiesService } from '../../services/opportunities.service';
import { Router } from '@angular/router';
import { SurplusLinesApplicant, SurplusLinesOpportunitySnapshot } from '../../models/surplus-lines-opportunity-snapshot.model';

@Component({
  selector: 'app-sign-and-submit',
  standalone: false,
  templateUrl: './sign-and-submit.component.html',
  styleUrl: '../../../assets/css/HighLimitsDialogs.css'
})
export class SignAndSubmitComponent {
  readonly dialogRef = inject(MatDialogRef<SignAndSubmitComponent>);
  signature: string = '';
  name: string = '';

  snackBarConfig: MatSnackBarConfig = {
    horizontalPosition: 'center',
    verticalPosition: 'top',
    duration: 5000
  };

  constructor(private _oss: OpportunitySnapshotsService,
    private _snackbar: MatSnackBar,
    private _ipService: IpAddressService,
    private _opportunityService: OpportunitiesService,
    private _router: Router,
  ) {
  }

  ngOnInit() {
    this.name = `${this._oss.currentApplicant?.FirstName as string} ${this._oss.currentApplicant?.LastName as string}`;
    
  }


  signatureCheck() {
    if (this.signature.toLowerCase() === this.name.toLowerCase()) {
      return false;
    }
    return true;
  }

  sign() {
    if (this.signatureCheck()) {
      this._snackbar.open('Signature name must match as shown', 'Close', this.snackBarConfig);
      return;
    } else {
      this._ipService.getIpAddress().subscribe((ip) => {
        localStorage.setItem('ip', ip.ip);

        const date = new Date();
        const timestampInMilliseconds = date.getTime();
        const timestampInSeconds = Math.floor(timestampInMilliseconds / 1000);
        const applicantInfo = localStorage.getItem('ApplicantInfo');
        const applicantId = applicantInfo
          ? (JSON.parse(applicantInfo) as SurplusLinesApplicant).Id ?? 0
          : 0;
        const applicantToken = applicantInfo
          ? (JSON.parse(applicantInfo) as SurplusLinesApplicant).Token ?? "" :"" ;
        this._oss.currentOppSnapByApplicantId(applicantId.toString(), applicantToken);

        var updateOpportunity = this._oss.currentOpportunitySnapshot;
        updateOpportunity.SignatureIP = ip.ip;
        updateOpportunity.Submitted = true;
        updateOpportunity.SubmittedTimestampSeconds = timestampInSeconds;
        updateOpportunity.InsuredId = this._oss.currentCompassOpportunity?.InsuredId as number;
        updateOpportunity.OwnerId = this._oss.currentCompassOpportunity?.OwnerId as number;
        updateOpportunity.Questions = this._oss.currentOpportunitySnapshot.Questions;
        updateOpportunity.OtherInsurance = this._oss.currentOpportunitySnapshot.OtherInsurance;
        updateOpportunity.QuestionnaireId = this._oss.currentQuote[0].QuestionnaireId;

        updateOpportunity.Questions = this.dedupeQuestions(updateOpportunity.Questions);
        
        this._oss.update(updateOpportunity);
        
        this._opportunityService.submit(updateOpportunity).subscribe((response) => {
         this._opportunityService.sendApplication(updateOpportunity, true, (updateOpportunity.HeightFt != "" && updateOpportunity.HeightIn != "" && updateOpportunity.WeightLbs != "")).subscribe((response) => {
            this._snackbar.open('Successfully Signed', 'Close', this.snackBarConfig);
            this.dialogRef.close(this.signature);
            this._router.navigate(['/receipt']);
          })
        });
      });

      this.dialogRef.close(this.signature);
    }
  }

  dedupeQuestions(questions: any[]): any[] {
    const seen = new Set<string>();
    return questions.filter((q) => {
      const key = JSON.stringify(q);
      if (seen.has(key)) {
        return false;
      }
      seen.add(key);
      return true;
    });
  }

  close() {
    this.dialogRef.close(false);
  }
}
